import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import { get } from "store";

Vue.use(Vuex);
export default {
  namespaced: true,
  state: {
    assets: [],
    assetTypes: []
  },
  getters: {
    assetTypes(state) {
      return state.assetTypes;
    },
    assets(state) {
      return state.assets;
    }
  },
  actions: {
    getAssetTypes({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let assetsRef = db
          .collection("listings")
          .doc("journey_assets")
          .collection("items");
        let assetTypes = [];
        assetsRef
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              assetTypes.push({
                assetId: doc.id,
                ...doc.data()
              });
              console.log("assetsTYPE", assetTypes);
            });
          })
          .catch(function(error) {
            console.log("Error getting tools documents: ", error);
          });
        commit("SET_ASSET_TYPES", assetTypes);
        res(assetTypes);
      });
    },
    getAssetsForType({ commit, state }, typeId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let assetTypeRef = db.collection(
          `listings/journey_assets/items/${typeId}/items`
        );
        let assets = [];
        console.log("assets", assetTypeRef.doc(typeId).get());
        assetTypeRef
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              assets.push({
                assetId: doc.id,
                ...doc.data()
              });
            });
          })
          .catch(function(error) {
            console.log("Error getting tools documents: ", error);
          });
        commit("SET_ASSETS", { assets, typeId });
        res(assets);
      });
    }
  },
  mutations: {
    SET_ASSET_TYPES(state, assetTypes) {
      //console.log("assetType", assetTypes);
      if (assetTypes) {
        state.assetTypes = assetTypes;
      } else {
        state.assetTypes = [];
      }
    },
    SET_ASSETS(state, { assets, typeId }) {
      if (assets) {
        state.assets[typeId] = assets;
      } else {
        state.assets[typeId] = [];
      }
    }
  }
};
